<form [formGroup]="vendorTCViewerForm" id="vendor-tc-viewer-form">
  <div class="container" id="vendor-tc-viewer-container">
    <div *ngIf="vendorTCViewerForm.invalid" id="vendor-tc-viewer-invalid-div">
      <mat-error id="vendor-tc-viewer-mat-error">Form is invalid</mat-error>
    </div>
    <div *ngIf="_vendorTermsAndConditions != undefined && _vendorTermsAndConditions != null" id="vendor-tc-viewer-terms-and-conditions-div">
      <read-only-form-field title="Vendor number" id="vendor-tc-viewer-vendor-id-input" value="{{_vendorTermsAndConditions.vendorId}}"/>
     
      <read-only-form-field title="Name" id="vendor-tc-viewer-name-input" value="{{_vendorTermsAndConditions.template.templateName}}"/>

      <read-only-form-field title="Description" id="vendor-tc-viewer-description-input" value="{{_vendorTermsAndConditions.template.templateDescription}}"/>

      <read-only-form-field title="Vendor Template Notes" id="vendor-tc-viewer-notes-input" value="{{_vendorTermsAndConditions.vendorTemplateNotes}}"/>
    </div>
    <br>
    <div class="row" id="vendor-tc-viewer-row">
      <ng-container #container id="vendor-tc-viewer-container"></ng-container>
    </div>
  </div>
</form>
